// OrdersMain.tsx
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// import OrderTable from "./OrderTable";
import { SearchAndFilterToolbar, StatusBar } from "../../components/common";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import enumChoice from "../../enum";
import { useQuery, useLazyQuery, gql } from "@apollo/client";
import {GraphQLPagination} from "../../components/common";
import Cookies from "js-cookie";

import { getQueryVariables } from "../../utils";
import PageTable from "./pageTable";

const GET_PAGES = gql`
    query GetPages(
        $first: Int
        $last: Int
        $after: String
        $before: String
        $slug: String
        $title: String
    ) {
        pages(
            first: $first
            last: $last
            after: $after
            before: $before
            slug: $slug
            title: $title
        ) {
            pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
            }
            edges {
                node {
                    title
                    slug
                    dbId
                }
            }
        }
    }
`;

const GET_STORE_URL = gql`
  query MyQuery {
    storeSettings {
      storeUrl
    }
  }
`;

function PageList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [getStoreUrl] = useLazyQuery(GET_STORE_URL);

  const { data, loading, error, refetch } = useQuery(GET_PAGES, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);

  const onCreateButtionInitClick = async () => {
    const storeUrl = Cookies.get('storeUrl');
    
    if (!storeUrl) {
      try {
        const { data: storeSettingsData } = await getStoreUrl();
        if (storeSettingsData?.storeSettings?.storeUrl) {
          Cookies.set('storeUrl', storeSettingsData.storeSettings.storeUrl);
        }
      } catch (error) {
        console.error('Error fetching store URL:', error);
      }
    }
    
    navigate("/dashboard/pages/editor");
  };

  return (
    <PageBodyWrapper>
      <StatusBar
        onButtonClick={onCreateButtionInitClick}
        statusList={[]}
        buttonLabel="Create Page"
        fieldName="status"
      />

     
      
      <div className="px-1">
        <PageTable orders={data?.pages?.edges || []} />
      </div>

      <GraphQLPagination 
        edges={data?.orders?.edges || []}
        pageInfo={data?.pages?.pageInfo || {}}
      />


    </PageBodyWrapper>
  );
}

export default PageList;